import React from 'react';
import styled from 'styled-components';
import { getNeutralColors } from '../theme';
import { useLoader } from './useLoader';

import LoaderImg from '../../assets/v2/gif/loader_zp_100x100.gif';
import LoaderImgU from '../../assets/v2/gif/loader_ur_250x250.gif';
import LoaderImgCm from '../../assets/v2/gif/loader-re-cm.gif';

const typeLoader = props => {
  let prop = null;
  if (props.isUrbania || process.env.REACT_APP_BUILD_SITE === 'UBPE') {
    prop = LoaderImgU;
  } else if (process.env.REACT_APP_BUILD_SITE === 'CMBR') {
    prop = LoaderImgCm;
  } else {
    prop = LoaderImg;
  }
  return prop;
};

const LoaderContainer = styled.div`
  background-color: ${getNeutralColors('white')};
  display: none;
  height: 100%;
  left: 0px;
  opacity: 0.8;
  position: fixed;
  top: 0px;
  width: 100%;
  z-index: 9999;
  &::after {
    background-image: url(${typeLoader});
    background-size: 100px 100px;
    content: '';
    height: 100px;
    width: 100px;
  }
  &.isActive {
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

function Loader({ isUrbania }) {
  const { toggleLoader } = useLoader();
  return <LoaderContainer isUrbania={isUrbania} className={toggleLoader ? `isActive` : ``} />;
}

export { Loader };
